module.exports = __webpack_public_path__ + "img/fig01.e960d4f9.jpg";